/** Draft FAQs render in dev, or anywhere `VITE_HELP_SHOW_DRAFTS=true` (e.g. the deployed demo). */
export const SHOW_DRAFT_FAQS: boolean = import.meta.env.DEV || import.meta.env.VITE_HELP_SHOW_DRAFTS === 'true';
